// @ts-nocheck
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  useTheme,
} from '@mui/material';
import { useCallback, useRef } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import MonacoEditor, { loader } from '@monaco-editor/react';
import PropTypes from 'prop-types';

import { NOOP } from '../../../../const/CommonConst';
import { registerCustomPython } from '../../../Monaco/monacoCustomPython';

loader.config({ paths: { vs: '/monaco' } });

const FormulaPreviewModal = ({
  open = false,
  onClose = NOOP,
  title = '',
  previewValue = '',
}) => {
  const theme = useTheme();
  const hoverProviderRef = useRef(null);

  // Memoized handler for MonacoEditor beforeMount
  const handleEditorBeforeMount = useCallback(
    (monaco) => {
      const derivedFormulaTheme =
        theme?.palette?.monacoEditor?.derivedFormulaEditor;
      if (hoverProviderRef.current) {
        hoverProviderRef.current.dispose();
        hoverProviderRef.current = null;
      }
      registerCustomPython(monaco, {
        tokenColors: derivedFormulaTheme?.tokenColors,
        colors: derivedFormulaTheme?.colors,
      });
      monaco?.editor?.setTheme('customPythonTheme');
    },
    [theme]
  );
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md">
      <DialogTitle>
        <Box component="span" aria-live="polite" aria-atomic="true">
          {title}
        </Box>
      </DialogTitle>

      <IconButton
        color="primary"
        aria-label="Close dialog"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 16,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent dividers>
        <Grid container spacing={4} rowSpacing={2}>
          <Grid item xs={12}>
            <MonacoEditor
              height="300px"
              language="custom-python"
              theme="customPythonTheme"
              value={previewValue}
              options={{
                minimap: { enabled: false },
                fontSize: 16,
                readOnly: true,
                scrollBeyondLastLine: false,
                wordWrap: 'on',
                placeholder: '',
                fixedOverflowWidgets: true, // The hover pop up should be on every element.
              }}
              beforeMount={handleEditorBeforeMount}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" title="Close" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

FormulaPreviewModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  title: PropTypes.string,
  previewValue: PropTypes.string,
};

export default FormulaPreviewModal;
